import * as React from 'react';
import { Footer } from '@bepure/tarkin';
import { SignUpNewsletterModalButton } from '../SignUpNewsletterModalButton/SignUpNewsletterModalButton';
import { FooterItem, SocialLink, SignUp, SignUpType } from '@bepure/tarkin';

interface Props {
    footerConfig: {
        thrawnURL: string;
        kenobiBlogURL: string;
    };
}
class PreLaunchFooter extends React.PureComponent<Props> {
    public render() {
        const buttonDescription = 'SIGN UP';
        // const logo: Logo = {
        //     link: 'https://static.bepure.co.nz/Arwen/Branding/EveByBePure_Logo_White.svg',
        //     name: 'Eve Logo',
        // };

        const learnItems: FooterItem[] = [
            {
                text: 'FAQs',
                link: '/faqs',
            },
            {
                text: 'Contact Us',
                link: '/contact-us',
            },
            {
                text: 'Terms & Conditions',
                link: '/terms-and-conditions',
            },
            {
                text: 'Privacy Policy',
                link: '/privacy-policy',
            },
            {
                text: 'Shipping and Returns',
                link: '/returns'
            },
            
            
            
            
        ];

        const socialLinks: SocialLink[] = [
            {
                link: 'https://www.facebook.com/evewellnessco/',
                image: 'https://static.bepure.co.nz/Arwen/Icons/Facebook_White.svg',
                alt: 'Facebook',
            },
            {
                link: 'https://www.instagram.com/evewellnessco_/',
                image: 'https://static.bepure.co.nz/Arwen/Icons/Instagram_White.svg',
                alt: 'Instagram',
            },
            {
                link: 'https://www.tiktok.com/@evewellness',
                image: 'https://s3.ap-southeast-2.amazonaws.com/static.bepure.co.nz/Arwen/Icons/Tiktok-01.svg',
                alt: 'TikTok',
            },
        ];

        const shopItems: FooterItem[] = [
            {
                text: 'Login',
                link: '/app/login'
            },
            {
                text: 'Register your Eve test',
                link: '/app/register-test-kit'
            },
            {
                text: 'Blog',
                onClick: this.goTo(this.props.footerConfig.kenobiBlogURL + '/blog'),
            },
            {
                text: 'Where to find Eve',
                link: '/stockists'
            }
        ];

        const accountItems: FooterItem[] = [
            {
                text: 'Register Your Test Kit',
                onClick: this.goTo(this.props.footerConfig.thrawnURL + '/register-test-kit'),
            },
            {
                text: 'Login',
                onClick: this.goTo(this.props.footerConfig.thrawnURL + '/login'),
            },
        ];

        const signUp: SignUp = {
            type: SignUpType.COMPONENT,
            component: <SignUpNewsletterModalButton buttonClasses={'btn btn--secondary disable-on-modal-open'} buttonText={buttonDescription} />,
        };

        return (
            <Footer
                learnItems={learnItems}
                socialLinks={socialLinks}
                shopItems={shopItems}
                accountItems={accountItems}
                signUp={signUp}
            />
        );
    }

    private goTo = (url: string) => (event: React.MouseEvent<HTMLButtonElement>) => {
        window.location.replace(url);
    }
}

export default PreLaunchFooter;
